/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useCallback } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useSmartLinkAnalytics } from '../../state/analytics';
import { SmartLinkModalProvider } from '../../state/modal';
import { HoverCardComponent } from './components/HoverCardComponent';
import { CardDisplay } from '../../constants';
import { di } from 'react-magnetic-di';
var HoverCardWithErrorBoundary = function HoverCardWithErrorBoundary(props) {
  var url = props.url,
    id = props.id,
    children = props.children;
  var analytics = useSmartLinkAnalytics(url, undefined, id);
  var onError = useCallback(function (error, info) {
    analytics.ui.renderFailedEvent({
      display: CardDisplay.HoverCardPreview,
      id: id,
      error: error,
      errorInfo: info
    });
  }, [analytics.ui, id]);
  return jsx(ErrorBoundary, {
    fallback: children,
    onError: onError
  }, jsx(SmartLinkModalProvider, null, jsx(HoverCardComponent, props, children)));
};
var HoverCardWithoutAnalyticsContext = withAnalyticsEvents()(HoverCardWithErrorBoundary);

/**
 * A hover preview component using within smart links,
 * e.g. inline card's hover preview and auth tooltip, flexible card's hover preview.
 *
 * This component contains additional props that smart-card internal components
 * use to configure hover preview behaviour.
 */
export var HoverCard = function HoverCard(props) {
  return jsx(HoverCardWithoutAnalyticsContext, props);
};

/**
 * A standalone hover preview component
 */
export var StandaloneHoverCard = function StandaloneHoverCard(props) {
  return jsx(HoverCard, props);
};